<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddUser" class="ml-auto">
                    <!-- <font-awesome-icon :icon="['fas', 'user-plus']" style="width:20px" class="color-brown" /> -->
                    <span class="color-brown">
                        add user
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="users" style="width: 100%">
                    <el-table-column label="image" prop="imageURL" width="80">
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="user Code" prop="userCode"/>
                    <el-table-column label="full name" prop="fullName"/>
                    <el-table-column label="email" prop="email"/>
                    <el-table-column label="phone" prop="phone"/>
                    <el-table-column label="user Type" prop="userType"/>
                    <el-table-column label="registration Date" prop="registrationDate"/>
                    <el-table-column label="Operations" width="150">
                        <template #default="scope">
                           
                             
                            <el-popconfirm 
                                title="Are you sure to reset this user passwrd?"
                                @confirm="resetUserPassword(scope.row.userCode)"
                                @cancel="false"
                            >
                                <template #reference>
                                    <font-awesome-icon :icon="['fas', 'key']" style="width:20px"  class="cursor-pointer color-yellow" />
                                </template>
                            </el-popconfirm>
                           
                                
                        </template>
                    </el-table-column>
                    
                    
                    <el-table-column label="status" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to change this user status?"
                                @confirm="changeUserStatus(scope.row)"
                                @cancel="scope.row.status = !scope.row.status "
                            >
                                <template #reference>
                                    <el-switch
                                        v-model="scope.row.status"
                                        class="mb-2"
                                    />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
                <div class="text-center">
                    <el-pagination 
                        @current-change="getAllUsers"
                        layout="prev, pager, next" 
                        :page-count="totalPages"
                        :page-size="pageSize"
                        :hide-on-single-page="true"
                        :current-page="pageNumber"
                    />
                </div>
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedUsers(){
            return JSON.parse(localStorage.getItem('adminStore'))?.admin.users?.list || []
        },
    },
    data(){
        return{
            users:[],
            totalPages:0,
            pageSize:0,
            pageNumber:1,
        }
    },
    mounted(){

        if (!this.cachedUsers.content?.length){
            this.getAllUsers(this.pageNumber);
        }else{
            this.users = this.cachedUsers.content;
            this.pageSize = this.cachedUsers.size;
            this.totalPages = this.cachedUsers.totalPages;
            this.pageNumber = this.cachedUsers.pageable.pageNumber + 1;
        }
    },
    
    methods:{
       
        async getAllUsers(pageNumber){
            this.pageNumber = pageNumber
            const response = await this.$store.dispatch('getAllUsers',pageNumber - 1);
            
            if (response.data.status == 1){
                this.users = response.data.content;
                this.pageSize = response.data.size;
                this.totalPages = response.data.totalPages;
            }
            
            
        },
    
        async changeUserStatus(userData){
            
            let dataToSend = {
                status: userData.status ? 'ACTIVATE' : "DEACTIVATE",
                userCode:userData.userCode
            }
            const response = await this.$store.dispatch('changeUserStatus',dataToSend);
            if (response.data.status == 1){
                this.$store.dispatch('setUsers',this.users)
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }else{
                const currentUser = this.users.find(user => user.id == userData.id )
                currentUser.status = !currentUser.status
            }
            
        },
       
        async handleAddUser(){
            this.$router.push({
                name:'manage-user',
            })
           
        },
        async handleEditUser(user){
            await this.$store.dispatch('storeCurrentUserToView',user)
            this.$router.push({
                name:'manage-user',
                params:{
                    slug:user.slug
                }
            })
        },
        async resetUserPassword(customerCode){

            const response = await this.$store.dispatch('resetUserPassword',customerCode);
            if (response.data.status == 1){
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }
            
        },
    }
}
</script>